import { ISelectOption } from '@apps-common/types/form'

export const UnitTaskStatus = {
  ready: 'ready',
  pending: 'pending',
  processing: 'processing',
  awaitingRetry: 'awaiting_retry',
  success: 'success',
  failed: 'failed',
  cancelled: 'cancelled'
}

export const UnitTaskSort = {
  dateAdded: 'DateAdded',
  dateUpdated: 'DateUpdated',
  status: 'Status'
}

export const UnitTaskType = {
  monitoringChange: 'monitoring_change',
  serverChange: 'server_change',
  serverBalance: 'server_balance'
}

export const UnitTaskLimit = {
  limit50: 50,
  limit100: 100,
  limit150: 150,
  limit200: 200,
  limit250: 250,
  limit300: 300,
  limit350: 350,
  limit400: 400,
  limit450: 450,
  limit500: 500
}

export enum PushProgramTaskStatusAction {
  pending = 'pending',
  processing = 'processing',
  awaitingRetry = 'awaiting_retry',
  success = 'success',
  cancelled = 'cancelled'
}

export const UNIT_TASK_UPDATE_LISTENER_STATUSES: string[] = [
  UnitTaskStatus.ready,
  UnitTaskStatus.pending,
  UnitTaskStatus.processing,
  UnitTaskStatus.awaitingRetry,
  UnitTaskStatus.failed
]

export const UNIT_TASK_STATUS_OPTIONS: ISelectOption[] = [
  { label: 'Ready', value: UnitTaskStatus.ready },
  { label: 'Pending', value: UnitTaskStatus.pending },
  { label: 'Processing', value: UnitTaskStatus.processing },
  { label: 'Awaiting Retry', value: UnitTaskStatus.awaitingRetry },
  { label: 'Success', value: UnitTaskStatus.success },
  { label: 'Failed', value: UnitTaskStatus.failed },
  { label: 'Cancelled', value: UnitTaskStatus.cancelled }
]

export const UNIT_TASK_ORDER_OPTIONS: ISelectOption[] = [
  { label: 'Date added', value: UnitTaskSort.dateAdded },
  { label: 'Date updated', value: UnitTaskSort.dateUpdated },
  { label: 'Status', value: UnitTaskSort.status }
]

export const UNIT_TASK_TYPE_OPTIONS: ISelectOption[] = [
  { label: 'Monitoring Change', value: UnitTaskType.monitoringChange },
  { label: 'Server Change', value: UnitTaskType.serverChange },
  { label: 'Server Balance', value: UnitTaskType.serverBalance }
]

export const UNIT_TASK_DEVICE_LIMIT_OPTIONS: ISelectOption[] = [
  { label: '50 Devices', value: UnitTaskLimit.limit50 },
  { label: '100 Devices', value: UnitTaskLimit.limit100 },
  { label: '150 Devices', value: UnitTaskLimit.limit150 },
  { label: '200 Devices', value: UnitTaskLimit.limit200 },
  { label: '250 Devices', value: UnitTaskLimit.limit250 },
  { label: '300 Devices', value: UnitTaskLimit.limit300 },
  { label: '350 Devices', value: UnitTaskLimit.limit350 },
  { label: '400 Devices', value: UnitTaskLimit.limit400 },
  { label: '450 Devices', value: UnitTaskLimit.limit450 },
  { label: '500 Devices', value: UnitTaskLimit.limit500 }
]

// status check arrays

export const UNIT_TASK_STATUS_DELETABLE_STATUSES = [
  UnitTaskStatus.ready,
  UnitTaskStatus.pending,
  UnitTaskStatus.failed,
  UnitTaskStatus.cancelled
]

export const UNIT_TASK_STATUS_RETRYABLE_STATUSES = [UnitTaskStatus.failed]

export const UNIT_TASK_STATUS_CANCELLABLE_STATUSES = [UnitTaskStatus.pending, UnitTaskStatus.processing, UnitTaskStatus.failed]

export const UNIT_TASK_STATUS_ARCHIVEABLE_STATUSES = [UnitTaskStatus.success, UnitTaskStatus.failed, UnitTaskStatus.cancelled]

export const UNIT_TASK_STATUS_EDITABLE_STATUSES = [UnitTaskStatus.ready, UnitTaskStatus.pending]

export const UNIT_TASK_QUEUE_STATUS_DELETABLE_STATUSES = [UnitTaskStatus.pending, UnitTaskStatus.failed, UnitTaskStatus.cancelled]

export const UNIT_TASK_QUEUE_STATUS_CANCELLABLE_STATUSES = [UnitTaskStatus.pending, UnitTaskStatus.failed]
